import letrusAPI from 'APIs/letrusAPI/axiosInstance';

export const fetchPedagogicalContentByIdService = (
  pedagogicalContentid?: string | number,
) => letrusAPI(`/api/v1/pedagogical_contents/${pedagogicalContentid}/`);
